import React, { Component } from "react";
import FillLayout from "../../layout/fill/FillLayout";
import CenterLayout from "../../layout/center/CenterLayout";

export default class FillLayoutDemo extends Component {
  render() {
    return (
      <FillLayout>
        <CenterLayout className="bg1">fill</CenterLayout>
      </FillLayout>
    );
  }
}



// WEBPACK FOOTER //
// ./src/layout/demo.fillLayout.js